import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busrentalserviceinsaswad() {



    const cardData =
    {
        keyword: 'Bus Rental Service in Saswad Pune',
        heading: 'Urbania on rent in pune: Bus Rental Service in Saswad Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Bus Rental Service in Saswad Pune for corporate groups, families, tourists, and event travelers seeking comfortable and spacious group transportation. Our well-maintained Force Urbania bus fleet provides ample seating, air-conditioned comfort, and smooth performance, making it ideal for local travel, airport transfers, weddings, corporate outings, sightseeing tours, and outstation journeys from Saswad. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from Saswad, Purandar, Hadapsar, Katraj, Kondhwa, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for bus rental services in Saswad Pune.',

        top: 'Top Places to Visit in Pune with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha glory. Known for its massive stone walls, grand gateways like Delhi Darwaza, and lush lawns, it served as the seat of Bajirao I’s administration. Despite being partially destroyed by fire, the remnants echo royal grandeur. Evening light-and-sound shows vividly bring Maratha history to life, making it a must-visit heritage site."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is a historical monument linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with Gandhi’s personal artifacts, photographs, and the samadhis of Kasturba and Mahadev Desai. Its sprawling gardens, Italian arches, and tranquil ambiance make it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The temple trust is known for charitable work. Devotees find immense peace and blessings here, making it the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a rugged hill, Sinhagad Fort is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to explore ancient ramparts, memorials, and scenic viewpoints. Local vendors offer traditional pithla-bhakri meals near the summit. The fort provides panoramic views of the Sahyadri ranges, blending history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase early Indian craftsmanship, making it Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a highlight, making it Pune’s living archive of art, craftsmanship, and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are especially mesmerizing, making Parvati Hill a spiritual and scenic highlight."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and spiritual transformation, making it Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Featuring flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers, it is ideal for families, photography enthusiasts, and peaceful strolls. The garden blends Japanese aesthetics with Indian nature, serving as Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot for locals. The vast waterscape and surrounding hills create picturesque views, especially during monsoon. Street vendors sell roasted corn and tea, adding local flavor. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy weekend escape and sunset viewpoint."
  }
],




"services": [
{
"name": "Bus Rental Service in Saswad Pune",
"description": "Bus Rental Service in Saswad Pune offers dependable and comfortable transportation solutions for all types of travel needs including local trips, events, and outstation journeys. The buses are well-maintained with spacious seating, clean interiors, and ample luggage space to ensure a smooth ride for passengers. With experienced drivers and a strong focus on safety and punctuality, this service is ideal for families, corporate groups, schools, and tourists traveling from Saswad and nearby areas."
},
{
"name": "Saswad Bus Hire Pune",
"description": "Saswad Bus Hire Pune provides flexible bus hire options for short and long-distance travel. The service ensures reliable vehicles, professional chauffeurs, and comfortable seating arrangements suitable for group travel. Whether for functions, tours, or daily needs, the buses are maintained to deliver safe and stress-free journeys, making it a trusted choice for residents and organizations in Saswad."
},
{
"name": "AC Bus Rental Saswad Pune",
"description": "AC Bus Rental Saswad Pune offers fully air-conditioned buses designed for comfortable travel in all seasons. These buses feature cushioned seating, clean interiors, and smooth ride quality, making long journeys relaxing for passengers. Ideal for weddings, corporate travel, and outstation trips, the service ensures professional drivers and timely travel schedules for a premium travel experience."
},
{
"name": "Non AC Bus Hire Saswad",
"description": "Non AC Bus Hire Saswad provides economical bus rental options for local and short-distance travel. These buses are spacious, clean, and well-suited for group outings, school trips, and budget-conscious travel. With reliable vehicles and trained drivers, the service ensures safe transportation while keeping costs affordable."
},
{
"name": "Corporate Bus Hire Saswad Pune",
"description": "Corporate Bus Hire Saswad Pune delivers organized and professional transportation services for offices and business groups. The service focuses on punctuality, comfort, and safety, making it suitable for employee transport, corporate meetings, and team outings. Well-maintained buses and experienced drivers ensure smooth travel for corporate passengers."
},
{
"name": "Bus for Wedding Saswad Pune",
"description": "Bus for Wedding Saswad Pune offers dedicated transportation for wedding guests, family members, and event participants. The buses provide spacious seating, clean interiors, and ample space for luggage and gifts. Professional drivers ensure timely pickups and drops across multiple venues, making wedding transportation organized and hassle-free."
},
{
"name": "Bus for Outstation Saswad Pune",
"description": "Bus for Outstation Saswad Pune provides reliable bus rental services for long-distance and interstate travel. The buses are designed for highway journeys with comfortable seating, sufficient legroom, and safety features. Experienced drivers familiar with outstation routes ensure smooth and secure travel for families, groups, and corporate travelers."
},
{
"name": "Bus Airport Transfer Saswad",
"description": "Bus Airport Transfer Saswad ensures timely and comfortable transportation to and from the airport for groups and families. The service offers punctual pickups, spacious luggage areas, and smooth travel experiences. Professional chauffeurs manage routes efficiently, reducing travel stress and ensuring on-time airport transfers."
},
{
"name": "Luxury Bus Hire Saswad Pune",
"description": "Luxury Bus Hire Saswad Pune provides premium buses with modern interiors, plush seating, and superior comfort for special occasions and VIP travel. Ideal for weddings, corporate events, and luxury tours, these buses combine elegance with safety and professional chauffeur services for an enhanced travel experience."
},
{
"name": "Affordable Bus Rental Saswad Pune",
"description": "Affordable Bus Rental Saswad Pune offers cost-effective transportation solutions without compromising on comfort or safety. The buses are clean, spacious, and reliable, making them suitable for families, students, and group travelers. This service is ideal for budget-friendly travel needs in and around Saswad."
},
{
"name": "Chauffeur Driven Bus Saswad Pune",
"description": "Chauffeur Driven Bus Saswad Pune ensures a worry-free journey with trained and verified drivers who prioritize safety and punctuality. Passengers can relax while experienced chauffeurs handle navigation and traffic efficiently. The service is suitable for events, tours, corporate travel, and group transportation."
},
{
"name": "Bus for Group Travel Saswad",
"description": "Bus for Group Travel Saswad provides spacious and well-coordinated transportation for large groups traveling together. With ample seating, luggage space, and professional drivers, the service ensures everyone reaches the destination comfortably and on time. Ideal for tours, functions, and social gatherings."
},
{
"name": "Best Bus Rental Saswad Pune",
"description": "Best Bus Rental Saswad Pune is known for quality vehicles, dependable service, and customer satisfaction. The buses are regularly maintained and suitable for various travel purposes including weddings, corporate travel, and outstation trips. Professional drivers and flexible rental options make it a preferred choice in Saswad."
},
{
"name": "Reliable Bus Service Saswad Pune",
"description": "Reliable Bus Service Saswad Pune focuses on consistent performance, safety, and timely transportation. The service offers well-maintained buses and experienced drivers to ensure smooth journeys for all passengers. Families, corporate clients, and groups trust this service for dependable travel solutions."
},
{
"name": "Local Bus Hire Saswad Pune",
"description": "Local Bus Hire Saswad Pune provides convenient transportation for short-distance and local travel needs. Ideal for daily travel, local events, and nearby outings, the buses offer comfortable seating and professional drivers. This service ensures easy and affordable local travel within Saswad and surrounding areas."
}
],
"tableData": [
["Bus Rental Service in Saswad Pune", "Saswad Bus Hire Pune"],
["AC Bus Rental Saswad Pune", "Non AC Bus Hire Saswad"],
["Corporate Bus Hire Saswad Pune", "Bus for Wedding Saswad Pune"],
["Bus for Outstation Saswad Pune", "Bus Airport Transfer Saswad"],
["Luxury Bus Hire Saswad Pune", "Affordable Bus Rental Saswad Pune"],
["Chauffeur Driven Bus Saswad Pune", "Bus for Group Travel Saswad"],
["Best Bus Rental Saswad Pune", "Reliable Bus Service Saswad Pune"],
["Local Bus Hire Saswad Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Bus Rental Service in Saswad Pune for Comfortable Travel",
        "WhyChoosedescription": "Bus Rental Service in Saswad Pune is ideal for local trips, family outings, group excursions, corporate travel, and leisure journeys, providing a smooth and enjoyable travel experience."
    },
    {
        "WhyChooseheading": "Spacious and Modern Buses",
        "WhyChoosedescription": "Our buses for rental in Saswad Pune are equipped with air-conditioning, comfortable reclining seats, ample legroom, and sufficient luggage space for all passengers."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "All drivers are licensed, trained, and experienced in Saswad Pune routes and nearby destinations, ensuring safe, punctual, and stress-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Bus Rental Service in Saswad Pune offers competitive pricing with no hidden charges, making group and leisure travel cost-effective and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for local tours, corporate trips, family journeys, multi-day travel, and customized plans tailored to your schedule."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All buses are regularly cleaned, sanitized, and maintained to ensure passenger comfort, hygiene, and safety throughout the journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Bus Rental Service in Saswad Pune guarantees on-time pickups, dependable service, and a smooth travel experience."
    }
]
}
const faqData = [
    {
        question: 'Can Bus Rental Service in Saswad Pune be booked for local and outstation travel?',
        answer: 'Yes, it can be booked for local tours within Saswad, outstation trips, family outings, corporate travel, and group journeys.'
    },
    {
        question: 'How can I book Bus Rental Service in Saswad Pune?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Bus Rental Service in Saswad Pune?',
        answer: 'This service offers spacious seating, professional drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced with Saswad Pune routes?',
        answer: 'Yes, all drivers are licensed, trained, and familiar with Saswad Pune city routes and popular nearby destinations.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off points are available across Saswad Pune and surrounding areas.'
    },
    {
        question: 'Is Bus Rental Service in Saswad Pune available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your trip.'
    },
    {
        question: 'Is this service suitable for families and corporate groups?',
        answer: 'Yes, Bus Rental Service in Saswad Pune is ideal for families, corporate groups, tourists, and large travel parties.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Mahesh Shinde',
        feedback: 'We rented a bus in Saswad Pune for our family trip. The journey was comfortable, the bus was clean, and the service was excellent.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Aarti Kale',
        feedback: 'Professional service with a friendly driver made our group travel smooth and enjoyable. Highly recommended!',
        rating: 5
    }
];


















































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Rental Service in Saswad Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/bus-rental-saswad.jpg",
  "description": "Bus Rental Service in Saswad Pune provides AC and Non-AC buses for one-way or round-trip travel, corporate trips, weddings, airport transfers, local travel, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in and around Saswad, Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/bus-rental-service-in-saswad-pune"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Bus Rental Service in Saswad Pune | AC & Non-AC Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Bus Rental Service in Saswad Pune for one-way or round-trip travel, corporate trips, weddings, airport transfers, local travel, and group travel. AC and Non-AC chauffeur-driven buses provide safe, comfortable, and convenient transportation in and around Saswad, Pune."
  />

  <meta
    name="keywords"
    content="Bus Rental Service in Saswad Pune, Saswad Bus Hire Pune, AC Bus Rental Saswad Pune, Non AC Bus Hire Saswad, Corporate Bus Hire Saswad Pune, Bus for Wedding Saswad Pune, Bus for Outstation Saswad Pune, Bus Airport Transfer Saswad, Luxury Bus Hire Saswad Pune, Affordable Bus Rental Saswad Pune, Chauffeur Driven Bus Saswad Pune, Bus for Group Travel Saswad, Best Bus Rental Saswad Pune, Reliable Bus Service Saswad Pune, Local Bus Hire Saswad Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/115.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busrentalserviceinsaswad;